// assets/rewards-page.js
(function () {
  'use strict';

  var MODAL_IDS = {
    join: 'rw-joinModalOverlay',
    info: 'rw-infoModalOverlay',
    birthday: 'rw-birthdayModalOverlay',
    refer: 'rw-referModalOverlay'
  };

  var activeOverlay = null;

  function openModal(overlay) {
    if (!overlay) return;
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    activeOverlay = overlay;
    var firstField = overlay.querySelector('input:not([readonly]), select');
    if (firstField) firstField.focus();
  }

  function closeModal(overlay) {
    if (!overlay) return;
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    if (activeOverlay === overlay) activeOverlay = null;
  }

  function closeAllModals() {
    document.querySelectorAll('.rw-modal-overlay.open').forEach(closeModal);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-modal]');
    if (trigger) {
      var key = trigger.getAttribute('data-modal');
      var overlay = document.getElementById(MODAL_IDS[key]);
      if (overlay) {
        e.preventDefault();
        if (key === 'info') {
          var title = overlay.querySelector('#rw-infoModalTitle');
          var body = overlay.querySelector('#rw-infoModalBody');
          if (title) title.textContent = trigger.getAttribute('data-modal-title') || '';
          if (body) body.textContent = trigger.getAttribute('data-modal-body') || '';
        }
        openModal(overlay);
      }
      return;
    }

    var closeBtn = e.target.closest('.rw-modal-close');
    if (closeBtn) {
      closeModal(closeBtn.closest('.rw-modal-overlay'));
      return;
    }

    if (e.target.classList.contains('rw-modal-overlay')) {
      closeModal(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllModals();
  });

  // Birthday day <select> — populate 1-31, matching the month-only static list in the markup.
  var daySelect = document.getElementById('rw-birthDaySelect');
  if (daySelect) {
    for (var d = 1; d <= 31; d++) {
      var opt = document.createElement('option');
      opt.value = String(d);
      opt.textContent = String(d);
      daySelect.appendChild(opt);
    }
  }

  // Birthday form has no real backend to save to yet — prevent the default
  // GET navigation and just close the modal.
  var birthdayForm = document.getElementById('rw-birthdayForm');
  if (birthdayForm) {
    birthdayForm.addEventListener('submit', function (e) {
      e.preventDefault();
      closeModal(birthdayForm.closest('.rw-modal-overlay'));
    });
  }

  // Refer-link copy-to-clipboard button.
  var copyBtn = document.getElementById('rw-referCopyBtn');
  var referInput = document.getElementById('rw-referLinkInput');
  if (copyBtn && referInput) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(referInput.value).then(function () {
        copyBtn.classList.add('copied');
        setTimeout(function () { copyBtn.classList.remove('copied'); }, 1800);
      }).catch(function () {
        referInput.select();
      });
    });
  }
})();
